import React from 'react';
import { Card } from '../UI/Card';
import { Zap, Users, BookOpen, Target, HeartHandshake, Lightbulb } from 'lucide-react';
export const SignaturePrograms = () => {
  const programs = [{
    title: 'AI Productivity Bootcamp',
    icon: <Zap className="w-8 h-8 text-white" data-id="element-1042" />,
    color: 'bg-blue-600',
    duration: '3-Day Intensive',
    audience: 'Professionals and Teams',
    outcomes: 'AI workflow mastery, 10x productivity, tool integration',
    description: 'A hands-on immersive experience designed to transform how your team works by integrating practical AI tools into their daily workflows.'
  }, {
    title: 'Strategic Networking Masterclass',
    icon: <Users className="w-8 h-8 text-white" data-id="element-1043" />,
    color: 'bg-primary',
    duration: '2-Day Program',
    audience: 'Leaders and Entrepreneurs',
    outcomes: 'Network strategy, relationship capital, visibility',
    description: 'Learn the art and science of building high-trust ecosystems and leveraging relationships for organizational and personal growth.'
  }, {
    title: 'AI for Educators Bootcamp',
    icon: <BookOpen className="w-8 h-8 text-white" data-id="element-1044" />,
    color: 'bg-gold-dark',
    duration: '3-Day Program',
    audience: 'Teachers and School Administrators',
    outcomes: 'AI-integrated teaching, curriculum innovation',
    description: 'Equip your teaching staff with the skills to use AI for lesson planning, grading, student engagement, and administrative efficiency.'
  }, {
    title: 'The Modern Marketing Team',
    icon: <Target className="w-8 h-8 text-white" data-id="element-1045" />,
    color: 'bg-purple-600',
    duration: '2-Day Workshop',
    audience: 'Marketing Teams',
    outcomes: 'Digital marketing mastery, content systems',
    description: 'Retool your marketing department with modern strategies, AI content workflows, and data-driven storytelling techniques.'
  }, {
    title: 'Community Building Masterclass',
    icon: <HeartHandshake className="w-8 h-8 text-white" data-id="element-1046" />,
    color: 'bg-emerald-600',
    duration: '2-Day Program',
    audience: 'Community Managers',
    outcomes: 'Engagement systems, community strategy',
    description: 'Master the frameworks for building, engaging, and sustaining vibrant online and offline communities for your brand or NGO.'
  }, {
    title: 'Program Design Lab',
    icon: <Lightbulb className="w-8 h-8 text-white" data-id="element-1047" />,
    color: 'bg-orange-600',
    duration: '3-Day Intensive',
    audience: 'Program Managers',
    outcomes: 'Impact-driven programs, evaluation frameworks',
    description: 'A collaborative lab where your team will design, structure, and create impact measurement frameworks for new initiatives.'
  }];
  return <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-1048">
      <div className="container mx-auto px-4" data-id="element-1049">
        <div className="text-center mb-16 scroll-animate" data-id="element-1050">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1051">
            Signature Training Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1052">
            Our flagship learning experiences designed for maximum impact and
            immediate application.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1053">
          {programs.map((program, index) => <Card key={index} className="scroll-animate overflow-hidden p-0 border-0 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" style={{
          transitionDelay: `${index % 3 * 100}ms`
        }} data-id="element-1054">
              <div className={`${program.color} p-6 flex justify-between items-start`} data-id="element-1055">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-1056">
                  {program.icon}
                </div>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-1057">
                  {program.duration}
                </span>
              </div>
              <div className="p-6 flex-grow flex flex-col bg-white" data-id="element-1058">
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1059">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow" data-id="element-1060">
                  {program.description}
                </p>

                <div className="space-y-3 pt-4 border-t border-gray-100 mt-auto" data-id="element-1061">
                  <div data-id="element-1062">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1" data-id="element-1063">
                      Who it's for
                    </span>
                    <span className="text-sm font-medium text-navy" data-id="element-1064">
                      {program.audience}
                    </span>
                  </div>
                  <div data-id="element-1065">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1" data-id="element-1066">
                      Expected Outcomes
                    </span>
                    <span className="text-sm font-medium text-primary" data-id="element-1067">
                      {program.outcomes}
                    </span>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};